import { styled } from '@/stitches.config';

import { Box, FormField } from '@base-app';

export const FormFieldStyled = styled(FormField, {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '$4',
  width: '275px',
});

export const StyledCustomContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '$6',
  textAlign: 'initial',
});

export const StyledButtonContainer = styled(Box, {
  marginTop: '$2',
});

export const FormContainer = styled(Box, {
  display: 'flex',
  flexWrap: 'wrap',
});
